<template>
  <!-- 管理员教育机构人才添加进度2 -->
  <div class="main-css">
    <div class="main-box">
      <!-- 标题部分 -->
      <div class="top-title">{{ $t("humanResourcesPosting") }}</div>
      <!-- 进度条部分 -->
      <div class="progress-bar">
        <div class="line-between-active"></div>
        <div class="progress-item-active">
          1 <span class="progress-title">{{ $t("resume") }}</span>
        </div>
        <div class="line-center-active"></div>
        <div class="progress-item-active">
          2<span class="progress-title">{{ $t("careerRequest") }}</span>
        </div>
        <div class="line-center-normal"></div>
        <div class="progress-item-normal">
          3<span class="progress-title">{{ $t("confirm") }}</span>
        </div>
        <div class="line-between-normal"></div>
      </div>
      <!-- 第一行 -->
      <div class="one-line-box">
        <div class="small-box">
          <p class="box-title">{{ $t("dateAdmission") }}<span>*</span></p>
          <div class="block">
            <el-date-picker
              v-model="enrollment"
              type="date"
              @blur="dataTimeChange1"
              format="yyyy-MM-dd"
              :placeholder="$t('registerDayselsect')"
            >
            </el-date-picker>
          </div>
        </div>
        <div class="small-box">
          <p class="box-title">{{ $t("graduationDate") }}<span>*</span></p>
          <div class="block">
            <el-date-picker
              v-model="graduation"
              type="date"
              @blur="dataTimeChange2"
              format="yyyy-MM-dd"
              :placeholder="$t('registerDayselsect')"
            >
            </el-date-picker>
          </div>
        </div>

        <div class="small-box">
          <p class="box-title">{{ $t("education") }}<span>*</span></p>
          <el-dropdown @command="handleCommand1">
            <span class="el-dropdown-link">
              {{ education }}<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="(item3, index) in educationData"
                :key="item3.code"
                :command="item3"
                >{{ item3.name }}</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
      <!-- 第二行 -->
      <div class="one-line-box">
        <div class="big-box">
          <p class="box-title">{{ $t("school") }}<span>*</span></p>
          <el-input
            v-model="school"
            @blur="inputData(1)"
            maxlength="100"
          ></el-input>
        </div>
        <div class="small-box">
          <p class="box-title">{{ $t("major") }}<span>*</span></p>
          <el-input
            v-model="profession"
            @blur="inputData(2)"
            maxlength="100"
          ></el-input>
        </div>
      </div>
      <!-- 第三行 -->
      <div class="one-line-box">
        <div class="small-box">
          <p class="box-title">{{ $t("startYear") }} <span>*</span></p>
          <div class="block">
            <el-date-picker
              v-model="startYear"
              type="date"
              @blur="dataTimeChange3"
              format="yyyy-MM-dd"
              :placeholder="$t('registerDayselsect')"
            >
            </el-date-picker>
          </div>
        </div>
        <div class="small-box">
          <p class="box-title">{{ $t("endDate") }} <span>*</span></p>
          <div class="block">
            <el-date-picker
              v-model="endYear"
              type="date"
              @blur="dataTimeChange4"
              format="yyyy-MM-dd"
              :placeholder="$t('registerDayselsect')"
            >
            </el-date-picker>
          </div>
        </div>
      </div>
      <!-- 第四行 -->
      <div class="one-line-box">
        <div class="big-box">
          <p class="box-title">{{ $t("workPlace") }}</p>
          <el-input
            v-model="workPlace"
            @blur="inputData(3)"
            maxlength="100"
          ></el-input>
        </div>
        <div class="small-box">
          <p class="box-title">{{ $t("belongs") }}</p>
          <el-input
            v-model="type"
            @blur="inputData(4)"
            maxlength="100"
          ></el-input>
        </div>
      </div>
      <!-- 第五行 -->
      <div class="one-line-box">
        <div class="small-box">
          <p class="box-title">{{ $t("preferredWorkplace") }}<span>*</span></p>
          <el-input
            v-model="hopeWorkplace"
            @blur="inputData(5)"
            maxlength="100"
          ></el-input>
        </div>
        <div class="small-box">
          <p class="box-title">{{ $t("desiredHireTime") }}<span>*</span></p>
          <div class="block">
            <el-date-picker
              v-model="hopeEntryTime"
              type="date"
              @blur="dataTimeChange5"
              format="yyyy-MM-dd"
              :placeholder="$t('registerDayselsect')"
            >
            </el-date-picker>
          </div>
        </div>
        <div class="small-box">
          <p class="box-title">
            {{ $t("desiredOccupationCategory") }}<span>*</span>
          </p>
          <el-dropdown @command="handleCommand2">
            <span class="el-dropdown-link">
              {{ hopeWorkType
              }}<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="(item2, index) in hopeWorktypeData"
                :key="item2.code"
                :command="item2"
                >{{ item2.name }}</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
      <!-- 第六行 -->
      <div class="label-line-box">
        <p class="box-title">{{ $t("employmentForm") }}</p>
        <div
          :class="hopeForm1 ? 'label-box-active' : 'label-box'"
          @click="labelIsShow(1)"
        >
          {{ $t("fullTimeEmployee") }}<span @click.stop="labelDel(1)">×</span>
        </div>
        <div
          :class="hopeForm2 ? 'label-box-active' : 'label-box'"
          @click="labelIsShow(2)"
        >
          {{ $t("partTimeJob") }}<span @click.stop="labelDel(2)">×</span>
        </div>
        <div
          :class="hopeForm3 ? 'label-box-active' : 'label-box'"
          @click="labelIsShow(3)"
        >
          {{ $t("specificSkill") }}<span @click.stop="labelDel(3)">×</span>
        </div>
        <div
          :class="hopeForm4 ? 'label-box-active' : 'label-box'"
          @click="labelIsShow(4)"
        >
          {{ $t("technicalInternTrainee")
          }}<span @click.stop="labelDel(4)">×</span>
        </div>
      </div>
      <!-- 第七行 -->
      <div class="one-line-box">
        <div class="max-small-box">
          <p class="box-title">{{ $t("expectedSalary") }} <span>*</span></p>
          <el-dropdown @command="handleCommand3">
            <span class="el-dropdown-link">
              {{ hopeSalary }}<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="(item3, index) in hopeSalaryData"
                :key="item3.code"
                :command="item3"
                >{{ item3.name }}</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div class="small-box margin-small-box">
          <el-input
            v-model="startSalary"
            @input="inputData(6)"
            maxlength="11"
          ></el-input>
        </div>
        <span class="tali">~</span>
        <div class="small-box">
          <el-input
            v-model="endSalary"
            @input="inputData(7)"
            maxlength="11"
          ></el-input>
        </div>
      </div>
      <!-- 第八行 -->
      <div class="big-line-box">
        <div class="big-box-css">
          <p class="box-title">{{ $t("otherWishes") }}<span>*</span></p>
          <el-input
            v-model="otherHope"
            type="textarea"
            @blur="inputData(8)"
            maxlength="255"
          ></el-input>
        </div>
      </div>
      <!-- 第九行 -->
      <div class="line-button-box">
        <button class="button-css1" @click="backClick">
          {{ $t("return") }}
        </button>
        <button class="button-css1" @click="saveClick" :disabled="isLock">
          {{ $t("temporarilySaved") }}
        </button>
        <button class="button-css2" @click="nextClick">{{ $t("next") }}</button>
      </div>
    </div>
  </div>
</template>
<script>
import { resumeAdd } from "../../js/api";
import axios from "axios";
import AES from "../../js/AES";

export default {
  name: "educationAdminTalentAdd2",
  components: {},
  data() {
    return {
      isLock: false,
      avatar: "", //写真
      anonym: "", //假名-----1
      //就职担当
      name: "", //姓名------1
      sex: "", //性别---1
      telephone: "", //电话
      email: "", //邮箱
      address: "", //现居住地
      birth: "",
      education: "",
      japanese: "", //日本语
      english: "", //英语
      other: "", //其他
      qualification1: "", //资格1
      qualification2: "",
      qualification3: "",
      pr: "", //自己pr--------1
      label1: 0, //标签1------1
      label2: 0,
      label3: 0,
      label4: 0,

      enrollment: "", //入学年月---2
      graduation: "", //毕业年月---2
      school: " ", //学校----2
      profession: "", //专业---2
      startYear: "", //开始年月
      endYear: "", //结束年月
      workPlace: "", //工作地点
      type: "", //所属
      hopeWorkplace: "", //希望工作地点
      hopeEntryTime: "", //希望工作时间
      hopeWorkType: "", //希望工作类型
      hopeForm1: 0, //希望雇用形态1
      hopeForm2: 0, //
      hopeForm3: 0, //
      hopeForm4: 0, //
      hopeSalary: "", //希望工资
      startSalary: 0, //开始工资
      endSalary: 0, //结束工资
      otherHope: "",

      labelListHandle: [],
      inoutData1: "",
      inputData2: "",
      inputData3: "",
      inputData4: "",
      educationData: [],
      inputData5: "",
      hopeWorktypeData: [],
      inputData6: "",
      hopeSalaryData: [],
      avatarUrl: "",
      dataItem1: "",
      dataItem2: "",
      dataItem3: "",
      judgeContinue: false,
      userId: ""
    };
  },
  created() {
    //获取当前语言的值
    this.language = window.localStorage.getItem("language");
    console.log(this.language, "语言");
    this.getLanguage1();
    this.getLanguage2();
    this.getLanguage3();
    this.avatar = this.$route.params.avatar;
    this.anonym = this.$route.params.anonym;
    this.name = this.$route.params.name;
    this.userId = this.$route.params.userId;
    this.sex = this.$route.params.sex;
    this.telephone = this.$route.params.telephone;
    this.email = this.$route.params.email;
    this.address = this.$route.params.address;
    this.birth = this.$route.params.birth;
    this.japanese = this.$route.params.japanese;
    this.english = this.$route.params.english;
    this.other = this.$route.params.other;
    this.qualification1 = this.$route.params.qualification1;
    this.qualification2 = this.$route.params.qualification2;
    this.qualification3 = this.$route.params.qualification3;
    this.pr = this.$route.params.pr;
    this.label1 = this.$route.params.label1;
    this.label2 = this.$route.params.label2;
    this.label3 = this.$route.params.label3;
    this.label4 = this.$route.params.label4;

    this.enrollment = this.$route.params.enrollment;
    this.graduation = this.$route.params.graduation;
    this.education = this.$route.params.education;
    this.school = this.$route.params.school;
    this.profession = this.$route.params.profession;
    this.startYear = this.$route.params.startYear;
    this.endYear = this.$route.params.endYear;
    this.workPlace = this.$route.params.workPlace;
    this.type = this.$route.params.type;
    this.hopeWorkplace = this.$route.params.hopeWorkplace;
    this.hopeEntryTime = this.$route.params.hopeEntryTime;
    // this.hopeForm1=this.$route.params.hopeForm1
    // this.hopeForm2=this.$route.params.hopeForm2
    // this.hopeForm3=this.$route.params.hopeForm3
    // this.hopeForm4=this.$route.params.hopeForm4
    this.startSalary = this.$route.params.startSalary;
    this.endSalary = this.$route.params.endSalary;
    this.otherHope = this.$route.params.otherHope;

    this.inputData1 = this.$route.params.inputData1;
    this.inputData2 = this.$route.params.inputData2;
    this.inputData3 = this.$route.params.inputData3;
    this.inputData4 = this.$route.params.inputData4;
    this.inputData5 = this.$route.params.inputData5;
    this.inputData6 = this.$route.params.inputData6;

    this.avatarUrl = this.$route.params.avatarUrl;
    this.getHopeEntryTime();
    this.gethopeWorkType();
    this.getHopeSalary();
  },
  computed: {},
  destroyed() {
    window.removeEventListener("setItemEvent", this.languageChange, true);
  },
  mounted() {
    window.addEventListener("setItemEvent", this.languageChange, true);
  },
  methods: {
    //监听语言
    languageChange(e) {
      const that = this;
      console.log("------监听数据------");
      console.log(e);
      if (e.key && e.key == "language" && e.newValue) {
        that.language = e.newValue;
        that.getLanguage1();
        that.getLanguage2();
        that.getLanguage3();
        that.getHopeEntryTime();
        that.gethopeWorkType();
        that.getHopeSalary();
      }
    },
    // input校验
    inputData(num) {
      var vc2 = /^\d{1,10}$/;
      var vc3 = /^.{1,99}$/;
      var vc4 = /^.{1,254}$/;

      if (num === 1) {
        console.log("1:" + this.school);
        if (this.school.length <= 0) {
          this.$message({
            message: this.$t("dataEmpty"),
            type: "warning"
          });
        } else if (!vc3.test(this.school)) {
          this.$message({
            message: this.$t("waringSchool"),
            type: "warning"
          });
        }
      } else if (num === 2) {
        if (this.profession.length <= 0) {
          this.$message({
            message: this.$t("dataEmpty"),
            type: "warning"
          });
        } else if (!vc3.test(this.profession)) {
          this.$message({
            message: this.$t("waringProfession"),
            type: "warning"
          });
        }
      } else if (num === 3) {
        if (!vc3.test(this.workPlace)) {
          this.$message({
            message: this.$t("waringWorkPlace"),
            type: "warning"
          });
        }
      } else if (num === 4) {
        if (!vc3.test(this.type)) {
          this.$message({
            message: this.$t("waringType"),
            type: "warning"
          });
        }
      } else if (num === 5) {
        if (this.hopeWorkplace.length <= 0) {
          this.$message({
            message: this.$t("dataEmpty"),
            type: "warning"
          });
        } else if (!vc3.test(this.hopeWorkplace)) {
        } else {
          this.$message({
            message: this.$t("waringHopeWorkplace"),
            type: "warning"
          });
        }
      } else if (num === 6) {
        if (!vc2.test(this.startSalary)) {
          //int
          this.$message({
            message: this.$t("waringStartSalary"),
            type: "warning"
          });
        }
      } else if (num === 7) {
        if (!vc2.test(this.endSalary)) {
          //int
          this.$message({
            message: this.$t("waringEndSalary"),
            type: "warning"
          });
        }
      } else if (num === 8) {
        if (this.otherHope.length <= 0) {
          this.$message({
            message: this.$t("dataEmpty"),
            type: "warning"
          });
        } else if (!vc4.test(this.otherHope)) {
          this.$message({
            message: this.$t("waringOtherHope"),
            type: "warning"
          });
        }
      }
    },
    getLanguage1() {
      if (this.language === "CN") {
        this.dataItem1 = "education";
      } else {
        this.dataItem1 = "jpeducation";
      }
    },
    getLanguage2() {
      if (this.language === "CN") {
        this.dataItem2 = "hopeWorktype";
      } else {
        this.dataItem2 = "jphopeWorktype";
      }
    },
    getLanguage3() {
      if (this.language === "CN") {
        this.dataItem3 = "hopeSalary";
      } else {
        this.dataItem3 = "jphopeSalary";
      }
    },
    //学历下拉框
    getHopeEntryTime() {
      var that = this;
      axios
        .get("/api/modules-parent/common/getDateItem", {
          params: {
            dataItem: that.dataItem1
          },
          headers: {
            "content-type": "application/x-www-form-urlencoded",
            token: localStorage.getItem("token")
          }
        })
        .then(function(res) {
          if (res.data.code === "A0000") {
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            that.educationData = aesFecInfo.data;
            console.log(that.educationData);
          } else {
            console.log(res.data);
            that.$message.error(res.data.message);
          }
        })
        .catch(res => {
          console.log(res);
        });
    },
    handleCommand1(evt) {
      this.inputData4 = evt.code;
      this.education = evt.name;
      console.log(evt);
    },
    //希望职业下拉框
    gethopeWorkType() {
      var that = this;
      axios
        .get("/api/modules-parent/common/getDateItem", {
          params: {
            dataItem: that.dataItem2
          },
          headers: {
            "content-type": "application/x-www-form-urlencoded",
            token: localStorage.getItem("token")
          }
        })
        .then(function(res) {
          if (res.data.code === "A0000") {
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            that.hopeWorktypeData = aesFecInfo.data;
            console.log(that.hopeWorktypeData);
          } else {
            console.log(res.data);
            that.$message.error(res.data.message);
          }
        })
        .catch(res => {
          console.log(res);
        });
    },
    handleCommand2(evt) {
      this.inputData5 = evt.code;
      this.hopeWorkType = evt.name;
      console.log(evt);
    },

    //希望工资下拉框
    getHopeSalary() {
      var that = this;
      axios
        .get("/api/modules-parent/common/getDateItem", {
          params: {
            dataItem: that.dataItem3
          },
          headers: {
            "content-type": "application/x-www-form-urlencoded",
            token: localStorage.getItem("token")
          }
        })
        .then(function(res) {
          if (res.data.code === "A0000") {
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            that.hopeSalaryData = aesFecInfo.data;
            console.log(that.hopeSalaryData);
          } else {
            console.log(res.data);
            that.$message.error(res.data.message);
          }
        })
        .catch(res => {
          console.log(res);
        });
    },
    handleCommand3(evt) {
      this.inputData6 = evt.code;
      this.hopeSalary = evt.name;
      console.log(evt);
    },
    dataTimeChange1() {
      this.enrollment = this.timeJs(this.enrollment);
    },
    dataTimeChange2() {
      this.graduation = this.timeJs(this.graduation);
    },
    dataTimeChange3() {
      this.startYear = this.timeJs(this.startYear);
    },
    dataTimeChange4() {
      this.endYear = this.timeJs(this.endYear);
    },
    dataTimeChange5() {
      this.hopeEntryTime = this.timeJs(this.hopeEntryTime);
    },
    timeJs(date) {
      //获取年份
      var y = date.getFullYear();
      //获取月份  返回0-11
      var m = date.getMonth() + 1;
      // 获取日
      var d = date.getDate();
      //获取星期几  返回0-6   (0=星期天)
      var w = date.getDay();
      //星期几
      var ww = " 星期" + "日一二三四五六".charAt(date.getDay());
      //时
      var h = date.getHours();
      //分
      var minute = date.getMinutes();
      //秒
      var s = date.getSeconds();
      //毫秒
      var sss = date.getMilliseconds();

      if (m < 10) {
        m = "0" + m;
      }
      if (d < 10) {
        d = "0" + d;
      }
      if (h < 10) {
        h = "0" + h;
      }
      if (minute < 10) {
        minute = "0" + minute;
      }
      if (s < 10) {
        s = "0" + s;
      }
      if (sss < 10) {
        sss = "00" + sss;
      } else if (sss < 100) {
        sss = "0" + sss;
      }
      return y + "-" + m + "-" + d;
    },
    //   标签高亮显示
    labelIsShow(num) {
      if (num === 1) {
        this.hopeForm1 = 1;
        this.labelListLength(1);
      } else if (num === 2) {
        this.hopeForm2 = 1;
        this.labelListLength(2);
      } else if (num === 3) {
        this.hopeForm3 = 1;
        this.labelListLength(3);
      } else if (num === 4) {
        this.hopeForm4 = 1;
        this.labelListLength(4);
      }
    },
    //判断labelListHandle长度 并且去重方法
    labelListLength(num) {
      if (this.labelListHandle.length < 4) {
        if (num === 1) {
          if (this.labelListHandle.indexOf("正社員") === -1) {
            this.labelListAdd(1);
          } else {
            return;
          }
        } else if (num === 2) {
          if (this.labelListHandle.indexOf("アルバイト") === -1) {
            this.labelListAdd(2);
          } else {
            return;
          }
        } else if (num === 3) {
          if (this.labelListHandle.indexOf("特定技能") === -1) {
            this.labelListAdd(3);
          } else {
            return;
          }
        } else if (num === 4) {
          if (this.labelListHandle.indexOf("技能実習生") === -1) {
            this.labelListAdd(4);
          } else {
            return;
          }
        } else {
          return;
        }
      }
    },
    //labelListHandle  push 方法
    labelListAdd(num) {
      if (num === 1) {
        this.labelListHandle.push("正社員");
      } else if (num === 2) {
        this.labelListHandle.push("アルバイト");
      } else if (num === 3) {
        this.labelListHandle.push("特定技能");
      } else if (num === 4) {
        this.labelListHandle.push("技能実習生");
      } else {
        return;
      }
      console.log(this.labelListHandle);
    },
    //标签删除方法
    labelDel(num) {
      if (num === 1) {
        for (var i = 0; i < this.labelListHandle.length; i++) {
          if (this.labelListHandle[i] === "正社員") {
            this.labelListHandle.splice(i, 1);
            this.hopeForm1 = 0;
          }
        }
      } else if (num === 2) {
        for (var i = 0; i < this.labelListHandle.length; i++) {
          if (this.labelListHandle[i] === "アルバイト") {
            this.labelListHandle.splice(i, 1);
            this.hopeForm2 = 0;
          }
        }
      } else if (num === 3) {
        for (var i = 0; i < this.labelListHandle.length; i++) {
          if (this.labelListHandle[i] === "特定技能") {
            this.labelListHandle.splice(i, 1);
            this.hopeForm3 = 0;
          }
        }
      } else if (num === 4) {
        for (var i = 0; i < this.labelListHandle.length; i++) {
          if (this.labelListHandle[i] === "技能実習生") {
            this.labelListHandle.splice(i, 1);
            this.hopeForm4 = 0;
          }
        }
      }
      console.log(this.labelListHandle);
    },
    judgeData() {
      console.log(this.startYear, "startYearstartYearstartYear");
      if (
        this.enrollment === "" ||
        this.graduation === "" ||
        this.education === "" ||
        this.school === "" ||
        !this.startYear ||
        !this.endYear ||
        this.profession === "" ||
        this.hopeWorkplace === "" ||
        this.hopeEntryTime === "" ||
        this.hopeWorkType === "" ||
        this.hopeSalary === "" ||
        this.otherHope === ""
      ) {
        this.$message({
          message: this.$t("dataEmpty"),
          type: "warning"
        });
        this.judgeContinue = true;
      } else {
        this.judgeContinue = false;
      }
    },
    backClick() {
      this.$router.push({
        path: "/educationAdminTalentAddOne",
        name: "educationAdminTalentAdd1"
      });
    },
    saveClick() {
      this.judgeData();
      this.isLock = true;
      if (this.judgeContinue === false) {
        var fakeInfo = {
          avatar: this.avatar, //写真
          anonym: this.anonym, //假名-----1
          //就职担当
          name: this.name, //姓名------1
          userId: this.userId,
          sex: this.inputData1, //性别---1
          telephone: this.name, //电话
          email: this.email, //邮箱
          address: this.address, //现居住地
          birth: this.birth, //出生年月--1
          japanese: this.inputData2, //日本语
          english: this.inputData3, //英语
          other: this.other, //其他
          qualification1: this.qualification1, //资格1
          qualification2: this.qualification2,
          qualification3: this.qualification3,
          pr: this.pr, //自己pr--------1
          label1: this.label1,
          label2: this.label2,
          label3: this.label3,
          label4: this.label4,
          enrollment: this.enrollment, //入学年月---2
          graduation: this.graduation, //毕业年月---2
          education: this.inputData4, //学历--2
          school: this.school, //学校----2
          profession: this.profession, //专业---2
          startYear: this.startYear, //开始年月
          endYear: this.endYear, //结束年月
          workPlace: this.workPlace, //工作地点
          type: this.type, //所属
          hopeWorkplace: this.hopeWorkplace, //希望工作地点
          hopeEntryTime: this.hopeEntryTime, //希望工作时间
          hopeWorkType: this.inputData5, //希望工作类型
          hopeForm1: this.hopeForm1, //希望雇用形态1
          hopeForm2: this.hopeForm2, //
          hopeForm3: this.hopeForm3, //
          hopeForm4: this.hopeForm4, //
          hopeSalary: this.inputData6, //希望工资
          startSalary: this.startSalary, //开始工资
          endSalary: this.endSalary, //结束工资
          otherHope: this.otherHope, //其他希望
          resumeId: "" //人才ID
        };
        resumeAdd(fakeInfo).then(res => {
          console.log("人才信息添加保存接口");
          console.log(res);
          if (res.data.code === "A0000") {
            this.isLock = false;
            this.$message({
              message: this.$t("saveSuccess"),
              type: "success"
            });
            this.$router.push("/educationalInstitutionTalentListView");
          } else {
            this.$message.error(this.$t("saveFail"));
          }
        });
      }
    },
    nextClick() {
      this.judgeData();
      if (this.judgeContinue === false) {
        this.$router.push({
          path: "/educationAdminTalentAddThree",
          name: "educationAdminTalentAdd3",
          params: {
            avatar: this.avatar, //写真
            anonym: this.anonym, //假名-----1
            //就职担当
            name: this.name, //姓名------1
            userId: this.userId,
            sex: this.sex, //性别---1
            telephone: this.telephone, //电话
            email: this.email, //邮箱
            address: this.address, //现居住地
            birth: this.birth,
            japanese: this.japanese, //日本语
            english: this.english, //英语
            other: this.other, //其他
            qualification1: this.qualification1, //资格1
            qualification2: this.qualification2,
            qualification3: this.qualification3,
            pr: this.pr, //自己pr--------1
            label1: this.label1,
            label2: this.label2,
            label3: this.label3,
            label4: this.label4,

            enrollment: this.enrollment, //入学年月---2
            graduation: this.graduation, //毕业年月---2
            education: this.education, //学历--2
            school: this.school, //学校----2
            profession: this.profession, //专业---2
            startYear: this.startYear, //开始年月
            endYear: this.endYear, //结束年月
            workPlace: this.workPlace, //工作地点
            type: this.type, //所属
            hopeWorkplace: this.hopeWorkplace, //希望工作地点
            hopeEntryTime: this.hopeEntryTime, //希望工作时间
            hopeWorkType: this.hopeWorkType, //希望工作类型
            hopeForm1: this.hopeForm1, //希望雇用形态1
            hopeForm2: this.hopeForm2, //
            hopeForm3: this.hopeForm3, //
            hopeForm4: this.hopeForm4, //
            hopeSalary: this.hopeSalary, //希望工资
            startSalary: this.startSalary, //开始工资
            endSalary: this.endSalary, //结束工资
            otherHope: this.otherHope, //其他希望

            inputData1: this.inputData1,
            inputData2: this.inputData2,
            inputData3: this.inputData3,
            inputData4: this.inputData4,
            inputData5: this.inputData5,
            inputData6: this.inputData6,
            avatarUrl: this.avatarUrl
          }
        });
      }
    }
  }
};
</script>
<style scoped>
.main-css {
  width: 100%;
  height: 100%;
  background: #fff;
}
.main-box {
  width: 700px;
  /* height: 100%; */
  margin: 0 auto;
  background: #fff;
  padding-bottom: 70px;
}
.top-title {
  height: 40px;
  line-height: 40px;
  text-align: center;
  font-weight: 500;
  font-size: 18px;
  color: #686868;
  margin-top: 20px;
}
.progress-bar {
  height: 40px;
  width: 100%;
  margin-top: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 40px;
}
.line-between-active {
  height: 2px;
  width: 80px;
  background: #51abff;
}
.line-between-normal {
  height: 2px;
  width: 80px;
  background: #dce3e9;
}
.progress-item-active {
  width: 20px;
  height: 20px;
  line-height: 20px;
  background: #51abff;
  border-radius: 50%;
  text-align: center;
  font-weight: 400;
  font-size: 13px;
  color: #ffffff;
  position: relative;
}
.progress-title {
  position: absolute;
  left: 50%;
  bottom: -30px;
  margin-left: -75px;
  display: block;
  height: 24px;
  width: 150px;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  text-align: center;
  color: #252a31;
}
.line-center-active {
  width: 160px;
  height: 2px;
  background: #51abff;
}
.line-center-normal {
  width: 160px;
  height: 2px;
  background: #dce3e9;
}
.progress-item-normal {
  width: 20px;
  height: 20px;
  line-height: 20px;
  background: #dce3e9;
  border-radius: 50%;
  text-align: center;
  font-weight: 400;
  font-size: 13px;
  color: #252a31;
  position: relative;
}

.one-line-box {
  height: 45px;
  width: 100%;
  margin-top: 15px;
  display: flex;
  align-items: center;
  padding-left: 55px;
  box-sizing: border-box;
}
.small-box {
  width: 160px;
  height: 44px;
  border: 2px solid #b2b2b2;
  box-sizing: border-box;
  border-radius: 8px;
  position: relative;
  margin-right: 48px;
}

.small-box /deep/ .el-input__inner {
  width: 150px;
  height: 40px;
  border: 2px solid transparent;
  box-sizing: border-box;
  margin-left: 4px;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: 0.25px;
  color: #09101d;
}
.box-title {
  padding: 0 5px;
  height: 20px;
  line-height: 20px;
  background: #ffffff;
  position: absolute;
  top: -10px;
  left: 10px;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #51abff;
  z-index: 10;
}
.box-title span {
  font-weight: 600;
  font-size: 12px;
  margin-left: 2px;
  color: #fc630c;
}
.small-box /deep/ .el-dropdown-link {
  width: 140px;
  height: 40px;
  line-height: 40px;
  display: inline-block;
}
.small-box /deep/ .el-dropdown {
  height: 40px;
  margin-left: 10px;
  line-height: 40px;
}
.small-box /deep/ .el-icon-arrow-down {
  float: right;
  line-height: 40px;
  margin-right: 5px;
}
.big-box {
  width: 368px;
  height: 44px;
  border: 2px solid #b2b2b2;
  box-sizing: border-box;
  border-radius: 8px;
  position: relative;
  margin-right: 48px;
}

.big-box /deep/ .el-input__inner {
  width: 355px;
  height: 40px;
  border: 2px solid transparent;
  box-sizing: border-box;
  margin-left: 4px;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: 0.25px;
  color: #09101d;
}
.max-small-box {
  width: 107px;
  height: 44px;
  border: 2px solid #b2b2b2;
  box-sizing: border-box;
  border-radius: 8px;
  position: relative;
  margin-right: 48px;
}

.max-small-box /deep/ .el-dropdown-link {
  width: 90px;
  height: 40px;
  line-height: 40px;
  display: inline-block;
}
.max-small-box /deep/ .el-dropdown {
  height: 40px;
  margin-left: 10px;
  line-height: 40px;
}
.max-small-box /deep/ .el-icon-arrow-down {
  float: right;
  line-height: 40px;
  margin-right: 5px;
}
.margin-small-box {
  margin-right: 10px;
}
.tali {
  font-weight: 400;
  font-size: 14px;
  color: #000000;
  margin-right: 10px;
}
.big-line-box {
  height: 127px;
  width: 580px;
  margin: 0 auto;
  margin: 25px 0 0 55px;
}
.big-box-css {
  height: 127px;
  width: 580px;
  background: #ffffff;
  border: 2px solid #b2b2b2;
  box-sizing: border-box;
  border-radius: 8px;
  position: relative;
}
.big-box-css /deep/ .el-textarea__inner {
  border: 1px solid transparent;
  height: 107px;
  width: 565px;
  margin-left: 2px;
  margin-top: 10px;
}

.line-button-box {
  height: 40px;
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 30px;
  padding: 0 0 0 55px;
  box-sizing: border-box;
}
.button-css1 {
  width: 85px;
  height: 40px;
  background: #fafafa;
  border: 1px solid #51abff;
  box-sizing: border-box;
  border-radius: 4px;
  font-weight: 500;
  font-size: 12px;
  color: #51abff;
  margin-right: 25px;
  cursor: pointer;
}
.button-css2 {
  width: 150px;
  height: 40px;
  background: #fc630c;
  border-radius: 4px;
  box-sizing: border-box;
  border-radius: 4px;
  font-weight: 500;
  font-size: 12px;
  color: #fff;
  cursor: pointer;
}
.label-line-box {
  width: 640px;
  height: 50px;
  margin: 0 auto;
  margin: 15px 0 0 55px;
  position: relative;
}
.label-box {
  float: left;
  height: 24px;
  padding: 0 5px;
  line-height: 24px;
  background: #b2b2b2;
  border-radius: 4px;
  font-weight: 400;
  font-size: 14px;
  color: #ffffff;
  cursor: pointer;
  overflow: hidden;
  margin-right: 20px;
  margin-top: 25px;
}
.label-box-active {
  float: left;
  height: 24px;
  padding: 0 5px;
  line-height: 24px;
  background: #51abff;
  border-radius: 4px;
  font-weight: 400;
  font-size: 14px;
  color: #ffffff;
  cursor: pointer;
  overflow: hidden;
  margin-right: 20px;
  margin-top: 25px;
}
.label-box-active span {
  height: 13px;
  width: 13px;
  background: #fff;
  border-radius: 50%;
  line-height: 13px;
  text-align: center;
  margin-left: 10px;
  display: inline-block;
  color: #b2b2b2;
}
.label-box span {
  height: 13px;
  width: 13px;
  background: #fff;
  border-radius: 50%;
  line-height: 13px;
  text-align: center;
  margin-left: 10px;
  display: inline-block;
  color: #b2b2b2;
}
.block /deep/ .el-input,
.el-date-editor.el-input__inner {
  width: 155px;
}
</style>



// WEBPACK FOOTER //
// src/pages/educationAdminTalentAdd2/index.vue